export const projectData     = state => state.project;
export const postProjectData = store => store.postProject;
export const globalReducer   = store => store.globalReducer;
export const creatorProfile  = store => store.creatorProfile;
export const chat  = store => store.chat;